import React, { useState, useEffect } from 'react';
import NavLinks from '../Navbar/NavLinks';
import { HashLink } from 'react-router-hash-link';
import logo from '../../images/logo/GravientLogo.png';
import { motion, useAnimation } from 'framer-motion';

const NavBar = () => {
  const [top, setTop] = useState(!window.scrollY);
  const [isOpen, setIsOpen] = useState(false);
  const controls = useAnimation();

  const handleClick = () => setIsOpen(!isOpen);

  useEffect(() => {
    const scrollHandler = () => {
      const isTop = window.scrollY < 10;
      setTop(isTop);

      controls.start({
        y: isTop ? 0 : -10,
        opacity: isTop ? 1 : 0.95,
        transition: { duration: 0.3 },
      });
    };

    window.addEventListener('scroll', scrollHandler);
    return () => window.removeEventListener('scroll', scrollHandler);
  }, [controls]);

  return (
    <motion.nav
      id="navbar"
      animate={controls}
      initial={{ y: 0, opacity: 1 }}
      className={`fixed top-0 w-full z-50 backdrop-blur-md transition duration-300 ease-in-out ${
        top ? 'bg-transparent' : 'bg-white shadow-lg'
      }`}
    >
      <div className="container mx-auto px-4 md:px-12 flex justify-between items-center py-1 md:py-2">
        {/* Logo */}
        <HashLink smooth to="/#hero" className="flex items-center gap-3">
          <img
            src={logo}
            alt="Gravient Technologies"
            className="h-14 w-14 sm:h-16 sm:w-16 md:h-20 md:w-20 object-contain"
          />
          <h1 className="font-extrabold text-2xl sm:text-3xl md:text-3xl text-[#15467a]">
            GRAVIENT TECHNOLOGIES
          </h1>
        </HashLink>

        {/* Desktop Links */}
        <div className="hidden lg:flex space-x-6">
          <NavLinks isMobile={false} />
        </div>

        {/* Mobile Menu Button */}
        <div className="lg:hidden flex flex-col items-center">
          <button className="p-2 rounded-lg text-[#15467a]" onClick={handleClick}>
            <svg className="h-6 w-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              {isOpen ? (
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
                />
              ) : (
                <path
                  fillRule="evenodd"
                  d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"
                />
              )}
            </svg>
          </button>

          {/* Mobile Menu */}
          <div
            className={`fixed top-16 left-0 w-full bg-white shadow-xl rounded-b-lg p-6 transition-transform duration-300 ${
              isOpen ? 'block' : 'hidden'
            }`}
          >
            <NavLinks isMobile={true} />
          </div>
        </div>
      </div>
    </motion.nav>
  );
};

export default NavBar;
